// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class CountriesService {

    index() {
        return axios.get(API_URL + 'countries', { headers: authHeader() })
    }
    show(id) {
        return axios.get(API_URL + 'countries/' + id, { headers: authHeader() })
    }
    store(resource) {
        return axios.post(API_URL + 'countries', resource, { headers: authHeader() })
    }
    update(resource) {
        return axios.put(API_URL + 'countries/' + resource.id, resource, { headers: authHeader() })
    }
    delete(resource) {
        return axios.delete(API_URL + 'countries/' + resource.id, { headers: authHeader() })
    }

    // get somalia
    defaultCountry(){  return axios.get(API_URL + 'default-country', { headers: authHeader() })}
}

export default new CountriesService()